/**
 * Samouczek 'Sprzedaz - paragon kuponem (karta podarunkowa)'.
 * Ksztalt danych: patrz frontend/src/pomoc/samouczki/KONTRAKT.md
 */
const OBRAZ = (plik, opis) => ({ plik, opis });

// Cztery dzialy = cztery sytuacje przy kasie: karta pokrywa calosc, karta nie
// pokrywa (doplata), klient ma dwie karty, i co sprawdzic po sprzedazy.
const DZIALY = {
  A: { tytul: 'Jedna karta pokrywa całość', opis: 'Najczęstszy przypadek. Klient płaci kartą podarunkową, na której jest więcej niż wynosi paragon.' },
  B: { tytul: 'Karta nie pokrywa całości — dopłata', opis: 'Na karcie jest mniej niż na paragonie. Resztę klient dopłaca gotówką, kartą płatniczą albo BLIK-iem.' },
  C: { tytul: 'Klient ma dwie karty', opis: 'Dwie (lub więcej) karty podarunkowe na jednym paragonie. System sam rozłoży kwotę między nie.' },
  D: { tytul: 'Po sprzedaży', opis: 'Gdzie sprawdzić, ile zostało na karcie, i skąd wiadomo, że karta została wykorzystana.' },
};

const PARAGON_KUPON = {
  id: 'paragon-kupon',
  dzialy: DZIALY,
  tytul: 'Sprzedaż — jak zrealizować paragon kuponem (kartą podarunkową)',
  dlaKogo: 'Kasjerzy',
  czas: '5 minut',
  pdf: '/instrukcje/paragon-kupon.pdf',
  wstep: 'Klient przychodzi z kartą podarunkową (kuponem) i chce nią zapłacić za zakupy. '
    + 'Kupon to zapisane w systemie saldo z kodem — kasa sprawdza je w chwili płatności i od razu '
    + 'odejmuje kwotę paragonu. Ten samouczek pokazuje trzy sytuacje: karta pokrywa całość, '
    + 'karta nie wystarcza i klient dopłaca, oraz klient płaci dwiema kartami.',
  kroki: [
    {
      n: 1,
      dzial: 'A',
      tytul: 'Nabij towar i kliknij „Dalej"',
      tresc: 'Dodaj produkty do koszyka jak przy każdej sprzedaży (skanerem albo wyszukiwarką — '
        + 'to opisuje osobny samouczek). Pod koszykiem jest zielony przycisk „Dalej". Po kliknięciu '
        + 'system pyta o aplikację SFD — zapytaj klienta i potwierdź „OK - Zapytalem". '
        + 'Dopiero wtedy pojawiają się metody płatności.',
      obraz: OBRAZ('/instrukcje/paragon-kupon-1-koszyk.jpg', 'Koszyk z jednym produktem i przycisk Dalej'),
    },
    {
      n: 2,
      dzial: 'A',
      tytul: 'Wybierz metodę „Kupon" i kliknij „Zaplac"',
      tresc: 'W części „Płatność" jest pięć metod: Gotówka, Karta, BLIK, Kupon, Dzielona. '
        + 'Kliknij „Kupon" — przycisk robi się fioletowy. Potem kliknij duży przycisk „Zaplac" '
        + 'z kwotą paragonu. Zamiast paragonu nic się jeszcze nie drukuje — najpierw otwiera się '
        + 'okno na kod karty.',
      obraz: OBRAZ('/instrukcje/paragon-kupon-2-metoda.jpg', 'Zaznaczona metoda Kupon i przycisk Zaplac'),
    },
    {
      n: 3,
      dzial: 'A',
      tytul: 'Zeskanuj kartę i kliknij „Sprawdź i zapłać"',
      tresc: 'W oknie „Płatność kuponem" u góry widzisz „Do zapłaty" — kwotę, którą ma pokryć karta. '
        + 'Kursor stoi już w polu „Kod kuponu:" — zeskanuj kod z karty albo wpisz go ręcznie '
        + '(wielkość liter nie ma znaczenia). Kliknij „Sprawdź i zapłać" albo wciśnij Enter. '
        + 'System sprawdza kartę: czy istnieje, czy jest aktywna, czy nie wygasła i czy saldo '
        + 'wystarcza. Jeśli wystarcza — od razu zamyka sprzedaż.',
      obraz: OBRAZ('/instrukcje/paragon-kupon-3-kod.jpg', 'Okno Płatność kuponem z wpisanym kodem karty'),
    },
    {
      n: 4,
      dzial: 'A',
      tytul: 'Sprawdź, że paragon się zapisał',
      tresc: 'Po chwili koszyk jest pusty, a w boksie „Paragony" u góry pojawia się nowy numer '
        + 'na szczycie listy. System pokazuje też komunikat „Paragon zostal pomyslnie zarejestrowany!". '
        + 'Z karty zeszła dokładnie kwota paragonu, reszta salda zostaje na niej do następnych zakupów. '
        + 'Jeśli karta nie przeszła (np. jest już wykorzystana albo wygasła), zobaczysz czerwony '
        + 'komunikat, a sprzedaż NIE zostaje zamknięta — koszyk czeka, możesz przyjąć zapłatę inaczej.',
      obraz: OBRAZ('/instrukcje/paragon-kupon-4-paragon.jpg', 'Boks Paragony z nowym numerem po sprzedaży kuponem'),
    },
    {
      n: 5,
      dzial: 'B',
      tytul: 'Zobacz, ile brakuje',
      tresc: 'Gdy zeskanowana karta ma mniej niż wynosi paragon, system nie odrzuca jej. Karta trafia '
        + 'na listę w oknie („Karta 1: kod, saldo, użyte") z całym swoim saldem, a pod nią '
        + 'pomarańczowy napis „Pozostaje X zł - dodaj kolejną kartę". Jeśli klient ma drugą kartę — '
        + 'przejdź do działu C. Jeśli chce dopłacić gotówką, kartą płatniczą albo BLIK-iem: '
        + 'kliknij „Anuluj" i użyj płatności „Dzielona".',
      obraz: OBRAZ('/instrukcje/paragon-kupon-5-pozostaje.jpg', 'Okno Płatność kuponem z kartą o zbyt małym saldzie i napisem Pozostaje'),
    },
    {
      n: 6,
      dzial: 'B',
      tytul: 'W oknie „Platnosc dzielona" wpisz kartę i resztę',
      tresc: 'Kliknij metodę „Dzielona" — otwiera się okno z wierszami: Gotowka, Karta, BLIK, Kupon. '
        + 'W wierszu „Kupon" zeskanuj kartę w pole „Kod kuponu" — po przejściu do następnego pola '
        + 'po prawej pojawia się „saldo … zl". W polu kwoty wpisz, ile ma zejść z karty (zwykle całe saldo). '
        + 'Potem w wierszu gotówki (albo karty płatniczej, albo BLIK) kliknij „Reszta" — system sam '
        + 'wpisze brakującą kwotę.',
      obraz: OBRAZ('/instrukcje/paragon-kupon-6-dzielona.jpg', 'Okno Platnosc dzielona z wypełnionym kuponem i gotówką'),
    },
    {
      n: 7,
      dzial: 'B',
      tytul: 'Sprawdź „Suma" i kliknij „Zaplac"',
      tresc: 'U góry okna „Suma" musi być równa „Do zaplaty" co do grosza — wtedy jest zielona, '
        + 'a przycisk „Zaplac" pomarańczowy. Gdy się nie zgadza, „Zaplac" jest szare. '
        + 'Po kliknięciu system jeszcze raz sprawdza kartę i zamyka sprzedaż. '
        + 'Jeśli klient ma tu dwie karty, przycisk „➕ Dodaj kolejną kartę" pod wierszem „Kupon" '
        + 'dodaje drugi wiersz na kolejny kod i kwotę.',
      obraz: OBRAZ('/instrukcje/paragon-kupon-7-zaplac.jpg', 'Suma równa kwocie do zapłaty i przycisk Zaplac'),
    },
    {
      n: 8,
      dzial: 'C',
      tytul: 'Zeskanuj drugą kartę',
      tresc: 'W oknie „Płatność kuponem" po pierwszej karcie (która nie pokryła całości) pole zmienia '
        + 'nazwę na „Kod kolejnej karty (2)". Zeskanuj drugą kartę i kliknij „Dodaj kartę" '
        + '(albo Enter). Kolejność ma znaczenie: z pierwszej karty schodzi całe saldo, z drugiej '
        + 'tylko to, co zostało do zapłaty. Pomyłkę cofniesz krzyżykiem „✕" przy karcie.',
      obraz: OBRAZ('/instrukcje/paragon-kupon-8-druga-karta.jpg', 'Pierwsza karta na liście i pole na kod drugiej karty'),
    },
    {
      n: 9,
      dzial: 'C',
      tytul: 'Kliknij „Zapłać kuponami"',
      tresc: 'Gdy karty razem pokrywają paragon, napis pod listą zmienia się na zielony: '
        + '„Karty pokrywają całą należność", a główny przycisk na „Zapłać kuponami". '
        + 'Przy każdej karcie widzisz „użyte … zł" — tyle z niej zejdzie. Kliknij „Zapłać kuponami". '
        + 'Na paragonie fiskalnym w części płatności drukuje się jedna linia „Kupon" z łączną kwotą, '
        + 'niezależnie od liczby kart.',
      obraz: OBRAZ('/instrukcje/paragon-kupon-9-zaplac-kuponami.jpg', 'Dwie karty na liście i przycisk Zapłać kuponami'),
    },
    {
      n: 10,
      dzial: 'D',
      tytul: 'Sprawdź saldo karty po sprzedaży',
      tresc: 'Klient pyta, ile mu zostało? Nad koszykiem kliknij „Sprawdz kupon", zeskanuj kartę '
        + 'i wciśnij Enter. Zielona ramka pokazuje status, aktualne saldo i datę ważności. '
        + 'To tylko podgląd — nic nie odejmuje. Możesz to zrobić także PRZED sprzedażą, '
        + 'żeby wiedzieć, czy karta wystarczy.',
      obraz: OBRAZ('/instrukcje/paragon-kupon-10-saldo.jpg', 'Okno Sprawdz kupon z saldem po sprzedaży'),
    },
    {
      n: 11,
      dzial: 'D',
      tytul: 'Zobacz status na liście kuponów',
      tresc: 'W menu po lewej wejdź w „Kupony" i wpisz kod w wyszukiwarkę. Karta, z której zeszło '
        + 'całe saldo, ma „0.00 zł" i czerwony status „Wykorzystany". Karta z resztą salda zostaje '
        + '„Aktywna" — w kolumnie WARTOŚĆ widzisz, ile na niej jest. W kolumnie PARAGON system sam '
        + 'wpisuje numer ostatniego paragonu, na którym karta została przyjęta.',
      obraz: OBRAZ('/instrukcje/paragon-kupon-11-lista.jpg', 'Lista kuponów ze statusami Wykorzystany i Aktywny'),
    },
    {
      n: 12,
      dzial: 'D',
      tytul: 'Otwórz historię karty',
      tresc: 'Przy kuponie kliknij „Akcje" i „Historia". Każde użycie karty to osobny wpis '
        + '„Wykorzystano … zł" z datą, numerem paragonu i loginem kasjera. Jedna karta użyta na '
        + 'kilku paragonach ma kilka takich wpisów.',
      obraz: OBRAZ('/instrukcje/paragon-kupon-12-historia.jpg', 'Okno Historia kuponu z wpisem Wykorzystano'),
    },
  ],
  uwagi: [
    'Kupon schodzi z salda dopiero w chwili zapisania paragonu — razem z nim. Jeśli klikniesz „Anuluj" '
      + 'albo sprzedaż zostanie odrzucona, z karty nic nie zeszło.',
    'Kuponu nie zamienisz na gotówkę. System przyjmuje go wyłącznie jako zapłatę za towar przy kasie; '
      + 'nie ma operacji wypłaty salda karty ani wydania reszty z kuponu.',
    'Towaru opłaconego kartą podarunkową nie przyjmujemy do zwrotu. Powiedz to klientowi przy sprzedaży, '
      + 'zanim zeskanujesz kartę.',
    'Tej samej karty nie zeskanujesz dwa razy na jednym paragonie — system odrzuci ją z komunikatem '
      + '„Ten sam kupon podano dwa razy". Każdą kartę podaj raz.',
    'Komunikat „Kupon został już wykorzystany" przy karcie, która według klienta ma saldo, najczęściej '
      + 'znaczy, że przed chwilą użyto jej na innej kasie. Sprawdź historię w module Kupony i przyjmij '
      + 'zapłatę inną metodą.',
    'Na liście kart w oknie płatności system pokazuje kod systemowy kuponu (8 znaków), nawet jeśli '
      + 'zeskanowałeś kod z fizycznej karty — to ta sama karta.',
  ],
};

export default PARAGON_KUPON;
